import { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router';
import { PATH_DASHBOARD } from '../routes/paths';
import Iconify from '../components/Iconify';
import { useGetTicketCountEvery5m } from '../pages/dashboard/tickets/hooks/useTickets';

const getCustomNavItems = (count) => ({
  clientes: [
    {
      subheader: 'Dashboards',
      items: [
        // {
        //   title: 'Home',
        //   path: PATH_DASHBOARD.acreditados.home,
        //   icon: <Iconify icon="ant-design:home-filled" />,
        // },
        {
          title: 'Resumen general',
          permissionName: 'Resumen general',
          path: PATH_DASHBOARD.acreditados.dashboard,
          icon: <Iconify icon="mdi:view-dashboard-outline" />,
          children: [
            {
              title: 'Cosechas',
              permissionName: 'Resumen general',
              path: `${PATH_DASHBOARD.acreditados.dashboard}?tab=cosechas`,
            },
            {
              title: 'Normalidad de cartera',
              permissionName: 'Resumen general',
              path: `${PATH_DASHBOARD.acreditados.dashboard}?tab=normalidad`,
            },
            {
              title: 'Motor vs matriz actual',
              permissionName: 'Resumen general',
              path: `${PATH_DASHBOARD.acreditados.dashboard}?tab=motor`,
            },
          ],
        },
        {
          title: 'Dashboard Dirección',
          permissionName: 'Dashboard Dirección',
          path: PATH_DASHBOARD.acreditados.powerBI,
          icon: <Iconify icon="mdi:chart-box-outline" />,
          children: [
            {
              title: 'KPI´s Dirección - Crédito',
              permissionName: 'Dashboard Dirección',
              path: PATH_DASHBOARD.acreditados.powerBI,
            },
            {
              title: 'Cosechas',
              permissionName: 'Dashboard Dirección',
              path: `${PATH_DASHBOARD.acreditados.powerBI}?dashboard=harvest-dashboard`,
            },
            {
              title: 'Normalidad de cartera',
              permissionName: 'Dashboard Dirección',
              path: `${PATH_DASHBOARD.acreditados.powerBI}?dashboard=portfolio-normality-dashboard`,
            },
          ],
        },
        {
          title: 'Dashboard Tienda',
          path: PATH_DASHBOARD.acreditados.store,
          icon: <Iconify icon="mdi:chart-box-outline" />,
        },
      ],
    },
    {
      subheader: 'Mesa de Control',
      items: [
        {
          title: 'Pase a Analista',
          path: PATH_DASHBOARD.controlTable.approvals,
          icon: <Iconify icon="material-symbols:fact-check-outline-rounded" />,
          badge: count,
        },
        {
          title: 'Conversaciones',
          path: PATH_DASHBOARD.controlTable.conversaciones,
          icon: <Iconify icon="bx:chat" />,
          children: [
            {
              title: 'Conversaciones',
              path: PATH_DASHBOARD.controlTable.conversaciones,
            },
            {
              title: 'Actualizar Estado',
              path: PATH_DASHBOARD.controlTable.conversacionesActualizarEstado,
            },
          ],
        },
        {
          title: 'Solicitudes',
          path: PATH_DASHBOARD.controlTable.requests,
          icon: <Iconify icon="carbon:request-quote" />,
        },
        {
          title: 'Préstamos Personales',
          path: PATH_DASHBOARD.controlTable.personalLoans,
          icon: <Iconify icon="mdi:cash-fast" />,
        },
        {
          title: 'Nómina créditos empleados',
          path: PATH_DASHBOARD.employeeCredits.payroll,
          icon: <Iconify icon="mdi:account-cash-outline" />,
        },
        {
          title: 'NIPs de Originación',
          path: PATH_DASHBOARD.controlTable.nips,
          icon: <Iconify icon="ph:key-bold" />,
        },
        {
          title: 'NIPs de Autenticación',
          path: PATH_DASHBOARD.controlTable.nipsAuth,
          icon: <Iconify icon="mdi:shield-key" />,
        },
        {
          title: 'Documentos Pendientes',
          path: PATH_DASHBOARD.controlTable.documentosPendientes,
          icon: <Iconify icon="carbon:document" />,
        },
      ],
    },
    {
      subheader: 'Clientes',
      items: [
        {
          title: 'Cartera Asignada',
          path: PATH_DASHBOARD.clientes.carteraAsignada,
          icon: <Iconify icon="mdi:wallet-bifold-outline" />,
        },
        {
          title: 'Clientes',
          path: PATH_DASHBOARD.clientes.clients,
          icon: <Iconify icon="mdi:user-check" />,
        },
      ],
    },
    {
      subheader: 'Campañas',
      items: [
        {
          title: 'Gestión de Mensajes',
          path: PATH_DASHBOARD.campañas.smsSettings,
          icon: <Iconify icon="mdi:message-text-outline" />,
        },
        {
          title: 'Programacion y Gestion',
          path: PATH_DASHBOARD.campañas.campaignsSettings,
          icon: <Iconify icon="mdi:calendar-multiple-check" />,
        },
        {
          title: 'Contacto Masivo',
          path: PATH_DASHBOARD.campañas.massContact,
          icon: <Iconify icon="mdi:account-multiple-plus-outline" />,
        },
        {
          title: 'Condonacion Masiva',
          path: PATH_DASHBOARD.campañas.condonacion,
          icon: <Iconify icon="mdi:hand-heart-outline" />,
        },
      ],
    },
    {
      subheader: 'Gestion de Cartera',
      items: [
        {
          title: 'Asignar Gestores',
          path: PATH_DASHBOARD.cartera.portfolioAssignationSettings,
          icon: <Iconify icon="mdi:account-switch-outline" />,
        },
        {
          title: 'Asignar Despachos',
          path: PATH_DASHBOARD.cartera.portfolioDespachoSettings,
          icon: <Iconify icon="carbon:cics-sit-overrides" />,
        },
        {
          title: 'Reasignacion',
          path: PATH_DASHBOARD.cartera.segmentPortfolioMirrorReasignation,
          icon: <Iconify icon="mdi:wallet-bifold-outline" />,
        },
      ],
    },
    {
      subheader: 'Core Life Cycle',
      items: [
        {
          title: 'Categorias',
          path: PATH_DASHBOARD.corelifecycle.categories,
          icon: <Iconify icon="material-symbols:diamond-outline" />,
        },
        {
          title: 'Reglas de Clientes',
          path: PATH_DASHBOARD.corelifecycle.rulesAdministration,
          icon: <Iconify icon="mdi:account-cog-outline" />,
        },
        {
          title: 'Reglas de Tiendas',
          path: PATH_DASHBOARD.corelifecycle.storesAdministration,
          icon: <Iconify icon="mdi:store-outline" />,
        },
        {
          title: 'Notificaciones',
          path: PATH_DASHBOARD.corelifecycle.operationalNotifications,
          icon: <Iconify icon="mingcute:notification-line" />,
        },
        {
          title: 'Asignaciones',
          path: PATH_DASHBOARD.corelifecycle.assignments,
          icon: <Iconify icon="mdi:clipboard-check-outline" />,
        },
      ],
    },
    {
      subheader: 'Configuracion',
      items: [
        {
          title: 'Seguridad',
          path: PATH_DASHBOARD.seguridad.root,
          icon: <Iconify icon="mdi:shield-lock-outline" />,
          children: [
            {
              title: 'Roles y Permisos',
              path: PATH_DASHBOARD.seguridad.menus,
            },
            {
              title: 'Mantenimiento de Usuarios',
              path: PATH_DASHBOARD.seguridad.employees,
            },
          ],
        },
        {
          title: 'Reglas Movimientos Especiales',
          path: PATH_DASHBOARD.rules.root,
          icon: <Iconify icon="mdi:shield-lock-outline" />,
          children: [
            {
              title: 'Liquidacion Anticipada',
              path: PATH_DASHBOARD.rules.liquidacion,
            },
            {
              title: 'Pre-Castigo',
              path: PATH_DASHBOARD.rules.applicationDebtSettings,
            },
            {
              title: 'Condonacion',
              path: PATH_DASHBOARD.rules.condonacion,
            },
          ],
        },
        {
          title: 'Mantenimiento Mayor',
          path: PATH_DASHBOARD.mantenimiento.root,
          icon: <Iconify icon="mdi:tools" />,
          children: [
            {
              title: 'Configuración de Segmentos de Cartera',
              path: PATH_DASHBOARD.mantenimiento.cartera,
            },
            {
              title: 'Aplicación de Segmentos',
              path: PATH_DASHBOARD.mantenimiento.reasignacion,
            },
            {
              title: 'Aplicación de Castigos',
              path: PATH_DASHBOARD.mantenimiento.castigo,
            },
            {
              title: 'Power BI',
              path: PATH_DASHBOARD.mantenimiento.powerBI,
            },
          ],
        },
        {
          title: 'Productos Financieros',
          path: PATH_DASHBOARD.financialProducts.root,
          icon: <Iconify icon="mdi:bank-outline" />,
          children: [
            {
              title: 'Alta',
              path: PATH_DASHBOARD.financialProducts.createProduct,
            },
            {
              title: 'Gestión',
              path: PATH_DASHBOARD.financialProducts.productlist,
            },
            {
              title: 'Prueba de Vida',
              path: PATH_DASHBOARD.financialProducts.legalarioLifeproof,
            },
            {
              title: 'Motor de decisión',
              path: PATH_DASHBOARD.financialProducts.creditDecisionEngine,
            },
          ],
        },
        {
          title: 'Tiendas',
          path: PATH_DASHBOARD.stores.root,
          icon: <Iconify icon="mdi:store" />,
        },
        {
          title: 'Soporte',
          path: PATH_DASHBOARD.support.root,
          icon: <Iconify icon="mdi:headset" />,
          children: [
            {
              title: 'Password',
              path: PATH_DASHBOARD.support.password,
            },
            {
              title: 'Documentos legalario',
              path: PATH_DASHBOARD.support.documents,
            },
            {
              title: 'Circulo de Crédito',
              path: PATH_DASHBOARD.support.creditCircle,
            },
            {
              title: 'Reenviar Liga',
              path: PATH_DASHBOARD.support.reenviarLiga,
            },
            {
              title: 'Gestionar enlace de firma',
              path: PATH_DASHBOARD.support.regenerarLiga,
            },
            {
              title: 'Ajuste de Línea',
              path: PATH_DASHBOARD.support.incrementoLinea,
            },
            {
              title: 'Actualizar Saldo de Cliente',
              path: PATH_DASHBOARD.support.updateClientWatcher,
            },
          ],
        },
        {
          title: 'Pagos',
          permissionName: 'Configuración de Pagos',
          path: PATH_DASHBOARD.payments.root,
          icon: <Iconify icon="mdi:credit-card-settings-outline" />,
          children: [
            {
              title: 'Pasarelas de Pago',
              path: PATH_DASHBOARD.payments.configuration,
            },
            {
              title: 'Dispersión',
              path: PATH_DASHBOARD.payments.dispersion,
            },
            {
              title: 'Habilitados para pagar',
              path: PATH_DASHBOARD.payments.access,
            },
          ],
        },
      ],
    },
    {
      subheader: 'Monitor',
      items: [
        {
          title: 'Watcher Report',
          path: PATH_DASHBOARD.watcherReport.root,
          icon: <Iconify icon="mdi:monitor" />,
        },
      ],
    },
    {
      subheader: 'Antifraude',
      items: [
        {
          title: 'Reglas Antifraude',
          path: PATH_DASHBOARD.antifraude.rules,
          icon: <Iconify icon="mdi:shield-alert-outline" />,
        },
        {
          title: 'Blacklist',
          path: PATH_DASHBOARD.antifraude.blacklist,
          icon: <Iconify icon="mdi:block-helper" />,
        },
        {
          title: 'Auditoría de Reglas',
          path: PATH_DASHBOARD.antifraude.ruleAudit,
          icon: <Iconify icon="mdi:clipboard-text-clock-outline" />,
        },
      ],
    },
    {
      subheader: 'Reportes',
      items: [
        {
          title: 'Eventos de Contacto',
          path: PATH_DASHBOARD.contacto.root,
          icon: <Iconify icon="material-symbols:call-log-outline-rounded" />,
          children: [
            {
              title: 'Individual',
              path: PATH_DASHBOARD.contacto.contactoIndividualReport,
            },
            {
              title: 'Masivo',
              path: PATH_DASHBOARD.contacto.contactoMassiveReport,
            },
          ],
        },
        {
          title: 'Eventos de Castigo',
          path: PATH_DASHBOARD.castigo.root,
          icon: <Iconify icon="mdi:account-lock" />,
          children: [
            {
              title: 'Eventos',
              path: PATH_DASHBOARD.castigo.goToCastigos,
            },
            {
              title: 'Detalle',
              path: PATH_DASHBOARD.castigo.castigoDetails,
            },
          ],
        },
        {
          title: 'Eventos de Condonacion',
          path: PATH_DASHBOARD.condonacion.root,
          icon: <Iconify icon="mdi:account-cash-outline" />,
          children: [
            {
              title: 'Individual',
              path: PATH_DASHBOARD.condonacion.condonacionIndividualReport,
            },
            {
              title: 'Masiva',
              path: PATH_DASHBOARD.condonacion.condonacionMassiveReport,
            },
          ],
        },
        {
          title: 'Originacion',
          path: PATH_DASHBOARD.originacion.root,
          icon: <Iconify icon="mdi:chart-box-outline" />,
          children: [
            {
              title: 'Reporte de Solicitudes',
              path: PATH_DASHBOARD.originacion.requests,
            },
            {
              title: 'Pases a Credito',
              path: PATH_DASHBOARD.originacion.goToCredit,
            },
            {
              title: 'Circulo de Credito',
              path: PATH_DASHBOARD.originacion.credit,
            },
            {
              title: 'Usuarios WebApp',
              path: PATH_DASHBOARD.originacion.webappUsers,
            },
          ],
        },
        {
          title: 'Configuración',
          path: PATH_DASHBOARD.configuracion.root,
          icon: <Iconify icon="mdi:cog-outline" />,
          children: [
            {
              title: 'Segmentaciones SGC',
              path: PATH_DASHBOARD.configuracion.segmentacionesSGC,
            },
            {
              title: 'Subsegmentaciones SGC',
              path: PATH_DASHBOARD.configuracion.subsegmentacionesSGC,
            },
            {
              title: 'Config. de sms y emails',
              path: PATH_DASHBOARD.configuracion.configSmsEmails,
            },
          ],
        },
        {
          title: 'Contactación',
          path: PATH_DASHBOARD.contactacion.root,
          icon: <Iconify icon="mdi:phone-outline" />,
          children: [
            {
              title: 'Clientes con promesas pago',
              path: PATH_DASHBOARD.contactacion.clientesPromesasPago,
            },
            {
              title: 'Trazabilidad clientes',
              path: PATH_DASHBOARD.contactacion.trazabilidadClientes,
            },
            {
              title: 'Asignaciones gestor',
              path: PATH_DASHBOARD.contactacion.asiganacionesGestores,
            },
            {
              title: 'Mensajes históricos',
              path: PATH_DASHBOARD.contactacion.mensajesHistoricos,
            },
          ],
        },
        {
          title: 'Reportes Campañas',
          path: PATH_DASHBOARD.campanas.root,
          icon: <Iconify icon="mdi:bullhorn-outline" />,
          children: [
            {
              title: 'Campañas configuradas SGC',
              path: PATH_DASHBOARD.campanas.campanasSGC,
            },
            {
              title: 'Condonaciones masivas',
              path: PATH_DASHBOARD.campanas.condonacionesMasivas,
            },
            {
              title: 'Mensajes a clientes',
              path: PATH_DASHBOARD.campanas.mensajesClientes,
            },
          ],
        },
        {
          title: 'Gestores',
          path: PATH_DASHBOARD.gestores.root,
          icon: <Iconify icon="mdi:account-tie" />,
          children: [
            {
              title: 'Montos recuperados',
              path: PATH_DASHBOARD.gestores.montosRecuperados,
            },
            {
              title: 'Productividad de gestores',
              path: PATH_DASHBOARD.gestores.productividadGestores,
            },
          ],
        },
        {
          title: 'Castigo',
          path: PATH_DASHBOARD.castigoReportes.root,
          icon: <Iconify icon="mdi:alert-circle-outline" />,
          children: [
            {
              title: 'Clientes en Prescastigo/Castigo',
              path: PATH_DASHBOARD.castigoReportes.clientesPrescastigoCastigo,
            },
            {
              title: 'Eventos Castigo Cartera',
              path: PATH_DASHBOARD.castigoReportes.eventosCastigoCartera,
            },
          ],
        },
        {
          title: 'Monitor de Pagos',
          path: PATH_DASHBOARD.reportes.paymentsMonitor,
          icon: <Iconify icon="mdi:file-check-outline" />,
        },
      ],
    },
  ],
  productosFinancieros: [
    {
      subheader: '',
      items: [
        {
          title: 'Crear Producto',
          path: PATH_DASHBOARD.financialProducts.createProduct,
          icon: <Iconify icon="mdi:add-circle-outline" />,
        },
        {
          title: 'Ver Productos Creados',
          path: PATH_DASHBOARD.financialProducts.productlist,
          icon: <Iconify icon="mdi:format-list-bulleted" />,
        },
        {
          title: 'Prueba de Vida',
          path: PATH_DASHBOARD.financialProducts.legalarioLifeproof,
          icon: <Iconify icon="mdi:face-recognition" />,
        },
        {
          title: 'Motor de decisión',
          path: PATH_DASHBOARD.financialProducts.creditDecisionEngine,
          icon: <Iconify icon="mdi:brain" />,
        },
      ],
    },
  ],
});

const getInitialNavItems = (pathname, CustomNavItems) =>
  // if (pathname.includes('/financialproducts')) return CustomNavItems.productosFinancieros;
  CustomNavItems.clientes;
const useNavItems = () => {
  const count = useGetTicketCountEvery5m();
  const { pathname } = useLocation();

  const CustomNavItems = useMemo(() => getCustomNavItems(count), [count]);

  const [navItems, setNavItems] = useState(() => getInitialNavItems(pathname, CustomNavItems));

  useEffect(() => {
    setNavItems(getInitialNavItems(pathname, CustomNavItems));
  }, [pathname, CustomNavItems]);

  return { navItems };
};

export default useNavItems;
